import React from 'react'
import '../../styles/IncreaseValueOverTimeStyles/floatingcoin.css'

import base from './../../resources/IncreaseValueOverTimeResources/floating-platform.svg'
import coin from './../../resources/IncreaseValueOverTimeResources/kronn-coin.svg'
import oval from './../../resources/IncreaseValueOverTimeResources/oval.svg'
import cpu from './../../resources/IncreaseValueOverTimeResources/cpu.svg'
import light from './../../resources/IncreaseValueOverTimeResources/light.svg'

export default class FloatingCoin extends React.Component{
    render(){
        return(
            <section className="fc__container">
                <img className="fc__base" src={base} />
                <img className="fc__coin" src={coin} />
                <div className="fc__light" />
                <div className="fc__ovals">
                    <img className="fc__oval-0" src={oval} />
                    <img className="fc__oval-1" src={oval} />
                    <img className="fc__oval-2" src={oval} />
                    <img className="fc__oval-3" src={oval} />
                    <img className="fc__oval-4" src={oval} />
                </div>

                <div className="fc__cpu-box">
                    <div className="fc__line-1" />
                    <img className="fc__cpu" src={cpu} />
                    <div className="fc__line-2" />
                    <div className="fc__line-3" />
                    <div className="fc__line-base" />

                    <div className="fc__orange-node" />
                    <div className="fc__green-node" />

                </div>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/IncreaseValueOverTime/FloatingCoin.js